import script from "./WechatLogin.vue?vue&type=script&setup=true&lang=js"
export * from "./WechatLogin.vue?vue&type=script&setup=true&lang=js"

import "./WechatLogin.vue?vue&type=style&index=0&id=c0d188d2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c0d188d2"]])

export default __exports__